module.exports = __webpack_public_path__ + "static/img/sc@3x.2b871f29.png";